// extracted by mini-css-extract-plugin
export default {"container":"templates-destination-reporting-module__container","sidebar":"templates-destination-reporting-module__sidebar"};